(function (app) {
    'use strict';

    app.factory('therapistServices', therapistServices);

    /*@ngInject*/
    function therapistServices(queryservice){
        return  {
            getTherapist:getTherapist
        };

        function getTherapist(cId, tId) {
            console.log('getTherapist' , cId, tId);
            // if(cId && tId){
                var fctArgsJson= {cId:cId, tId:tId};
                var fctName= "obtAdvHelper.getTherapistsInfo";
                return queryservice.callServer(fctName,fctArgsJson)
                    .then(getFirstFromArray)
                    //.catch(function(){console.log('momo')}).finally(function(){console.log('hoho')});
            // }
        }

        function getFirstFromArray(data){
            console.debug('getTherapist -- getFirstFromArray' , JSON.stringify(data));
            return data ? data[0] : {};
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/therapist.services.js
 ** module id = 170
 ** module chunks = 0
 **/